import {createSelector} from '@reduxjs/toolkit'

import {ChildInfo, ChildInfoType, UserAuthStatus} from '@web/core/constants'

import {RootState} from './interfaces'

export const purchaserSelector = (state: RootState) => state.purchaser

export const phoneNumberSelector = (state: RootState) => state.purchaser.phoneNumber

export const alarmTypeSelector = (state: RootState) => state.purchaser.alarmType

export const purchaserNameSelector = (state: RootState) => state.purchaser.name

/** 환불방법 */
export const refundMethodTypeSelector = (state: RootState) => state.purchaser.refundMethodType

/** 19 세 이상 여부 */
export const isAdultUserInRealAgeSelector = (state: RootState) => state.purchaser.adult

/** 19 세 이상 정보 */
export const adultInfoSelector = createSelector(
    (state: RootState) => state.purchaser.adult,
    (state: RootState) => state.purchaser.adultAuthentication,
    (state: RootState) => state.purchaser.child,
    (isAdult, adultAuthentication, child) => {
        return {
            isAdult,
            childType: (function (): ChildInfoType {
                if (isAdult) {
                    return ChildInfo.ADULT
                }
                if (child) {
                    return ChildInfo.CHILD
                }
                return child === false ? ChildInfo.MINOR : ChildInfo.UNKNOWN
            })(),
            unknownBirthday: child === null,
            isRequired: adultAuthentication.isRequired,
            token: adultAuthentication.token,
            certificationMethod: adultAuthentication.certificationMethod,
        }
    },
)

/** 환불 계좌 목록 정보 */
export const refundAccountsSelector = (state: RootState) => state.purchaser.refundAccounts

/** 대표 환불 계좌 정보 */
export const defaultRefundAccountSelector = createSelector(refundAccountsSelector, (refundAccounts) =>
    refundAccounts.find((account) => account.defaultRefundAccount),
)

/** 멤버십 정보 */
export const membershipInfoSelector = (state: RootState) => state.purchaser.naverMembership

/** 멤버십 PLCC 정보 */
export const membershipPlccSelector = (state: RootState) => state.purchaser.naverMembership.membershipPlcc

export const currentEpisodeInfoSelector = (state: RootState) => state.purchaser.naverMembership.currentEpisode

/** 멤버십 적립 혜택 현황 레이어 노출 여부 */
export const membershipBenefitLayerExposedSelector = (state: RootState) =>
    state.purchaser.naverMembership.membershipBenefitLayerExposed

export const isRestrictedUserSelector = (state: RootState) => state.purchaser.isAMLTarget ?? false

export const userAuthStatusInfoSelector = createSelector(purchaserSelector, ({userAuthStatus}) => {
    return {
        isAnonymous: userAuthStatus === UserAuthStatus.ANONYMOUS,
        userAuthStatus,
    }
})
